'use strict';

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var dropdDownInitialization = require('../components/selectDropDown');
var validation = require('../helpers/validationFunction');
var CUSTOM_MOENGAGE = require('../moengage');
var duoViewport = require('../components/duoViewport');
// iPhone Duo unfolded (669px portrait / 951px landscape) is still a phone;
// landscape trips the >=768 check and skipped the mobile-only branches.
var isMobile = !($(window).width() >= 768) || duoViewport.isUnfolded();
$(document).ready(function () {
    dropdDownInitialization.initiateSelectDropDown('#nationality',resources.labelSearch, resources.labelNoCountry);
});

module.exports = {
    login: function () {
        $('form.login').on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            var gTagData;
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    gTagData = {
                        email: $(form).find('[name="loginEmail"]')[0].value
                    };
                    if (!data.success) {
                        formValidation(form, data);
                        $.toastr().error(data.error[0]);
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    } else {
                        $('form.login').trigger('login:success', data);
                        if (data && data.customerdataMoE) {
                            gTagData = Object.assign({}, gTagData, data.customerdataMoE, { dateOfBirth: data.customerdataMoE.dob });
                        }
                        if (typeof Moengage !== 'undefined' && Moengage) {
                            CUSTOM_MOENGAGE.trackUserEvents(CUSTOM_MOENGAGE.MOENGAGE_EVENT_NAME.loginSuccess, gTagData, data.redirectUrl);
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        $.toastr().error(data.message);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        $('form.registration').submit(function (e) {
            var form = $(this);
            var gTagData;
            e.preventDefault();
            var url = form.attr('action');
            $('form.registration').trigger('login:register', e);
            var formData = form.serialize() + '&isMobile=' + isMobile;
            if ($('form.registration').data('isregistrationactivated')) {
                var otpFieldName = $('#registeration-step-2').find('#registration-form-verification-code').attr('name');
                var otpValue = $('#registeration-step-2').find('#registration-form-verification-code').val();
                formData += '&' + otpFieldName + '=' + otpValue;
            }
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success: function (data) {
                    gTagData = {
                        email: $(form).find('#registration-form-email')[0].value,
                        firstName: $(form).find('#registration-form-fname')[0].value,
                        lastName: $(form).find('#registration-form-lname')[0].value,
                        gender: $(form).find('.gender-container  input[type=radio]:checked').val(),
                        countryCode: $(form).find('#countrycode').val(),
                        mobileNumber: $(form).find('#registration-form-phone')[0].value,
                        dateOfBirth: $(form).find('#js-birthday')[0].value,
                        nationality: $(form).find('#nationality').val(),
                        userID: data.userID
                    };
                    $(document).trigger('register:success', gTagData);
                    if ('OtpFlow' in data && data.OtpFlow && 'success' in data && data.success) {
                        $('#registeration-step-1').fadeOut(50, function () {
                            $('#registeration-step-2').fadeIn(100);
                        });
                        $('form.registration').attr('action', data.accountRegisterURL);
                        $('form.registration').data('isregistrationactivated', true);
                        var timer = $('.resendSms').data('enableforseconds');

                        var counter = timer;
                        var interval = setInterval(function () {
                            counter--;
                            // Display 'counter' wherever you want to display it.
                            if (counter <= 0) {
                                clearInterval(interval);
                                $('.resendSms').removeClass('disabled');
                                $('.timerText').hide();
                                $('.timerText span').html(timer);
                                return;
                                // eslint-disable-next-line no-else-return
                            } else {
                                $('.timerText span').text(counter);
                            }
                        }, 1000);
                    } else if ('OtpFlow' in data && data.OtpFlow && 'success' in data && !data.success) {
                        formValidation(form, data);
                        $('form.registration').data('isregistrationactivated', false);
                        $.toastr().error(data.message);
                    } else if (!data.success) {
                        // check if otp error is there display it on frontend
                        if ('fields' in data && 'dwfrm_profile_verificationcode' in data.fields) {
                            formValidation($('#registeration-step-2'), data);
                        } else {
                            formValidation(form, data);
                        }
                    } else {
                        if (typeof Moengage !== 'undefined' && Moengage) {
                            CUSTOM_MOENGAGE.trackUserEvents(CUSTOM_MOENGAGE.MOENGAGE_EVENT_NAME.registrationSuccess, gTagData, data.redirectUrl);
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $(document).trigger('register:error', gTagData);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }
                    $.spinner().stop();
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.reset-password-form').addClass('d-none');
                        $('.reset-success-container').removeClass('d-none');
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    openPassWordResetPopup: function () {
        $('#password-reset').on('click', function () {
            $('#requestPasswordResetModal .reset-password-form-man').show();
            $('#requestPasswordResetModal .request-password-msg').hide();
            $('#requestPasswordResetModal #reset-password-email').val('');
        });
    },

    mobileOtpFill: function () {
        $('.singleOtp').first().focus();
        var submitCount = 1;
        var tA = false;
        // eslint-disable-next-line consistent-return
        $('.singleOtp').keyup(function ({key}) {
            var len = $(this).val().toString().length;
            var act = $(this).closest('.otp-content').find('.combineOtp');
            var accumulatedValue = '';

            if (["Backspace", "Delete"].includes(key)) {
                $(this).val('');
                $(this).prev().focus();
            } else if (len === 1) {
                $(this).next().focus();
            }

            // eslint-disable-next-line consistent-return
            $('.singleOtp').each(function () {
                var $trim = $(this).val();
                $trim = $.trim($trim);
                accumulatedValue += $trim;
                if ($trim.length !== 0 && accumulatedValue.length === 4) {
                    act.val(accumulatedValue);
                    if (submitCount === 1 || tA) {
                        $.spinner().start();
                        $('form.registration').submit();
                        setTimeout(() => {
                            tA = true;
                        }, 3000);
                        tA = false;
                        submitCount++;
                    }
                    return false;
                }
            });
        });
        $(".singleOtp").on("paste", function (event) {
            var pastedData = (event.originalEvent || event).clipboardData.getData('text/plain');
            if (pastedData.length === 4 && /^[0-9]+$/.test(pastedData)) {
                // Extract individual digits
                var digits = pastedData.split("");

                // Populate each input field with one digit
                $(".singleOtp").each(function (index) {
                    if (index < 4) {
                        $(this).val(digits[index]); // Set value
                    }
                });
                $(this).trigger('keyup');
            } else {
                alert("Please paste a valid 4-digit verification code.");
            }
        });
    },

    handleOtpScreenBackButton: function () {
        $('body').on('click', '.js-open-registration-first', function () {
            $('#registeration-step-2').fadeOut(50, function () {
                var verifyURL = $('#registeration-step-1').data('verify-url');
                $('#registeration-step-1').find('form.registration').attr('action', verifyURL);
                $('#registeration-step-1').fadeIn(100);
                $('.new-login-tabs').fadeIn();
            });
        });
    },

    handleResendOtpLink: function () {
        $(document).on('click', '.resendSms', function (e) {
            e.preventDefault();
            $(this).addClass('disabled').addClass('d-none');
            $('.js-verify-phone-btn').addClass('js-re-sent-sms').trigger('click');
        });
    },

    registerDeirect: function () {
        $('.js-directRegister').on('click', function (e) {
            e.preventDefault();
            $(this).closest('form').submit();
        });
    },

    registerOTP: function () {
        var $module = this;
        $('.js-verify-phone-btn').on('click', function (e) {
            e.preventDefault();
            $('.resendSms').addClass('disabled').addClass('d-none');
            $('.timerText').show();
            var url = $(this).data('verification-url');
            var $form = $('#registeration-form');
            var countryCode = $('#countrycode').val();
            var email = $('#registration-form-email').val();
            var phoneValue = $('#registration-form-phone').val();
            var phoneNumber = countryCode + phoneValue;

            var data = {
                phoneNumber: phoneNumber,
                email: email,
                countryCode: countryCode
            };
            if ($(this).hasClass('js-re-sent-sms')) {
                data = {
                    phoneNumber: phoneNumber
                };
            }
            var csrfField = $('.js-csrf');
            data[csrfField.attr('name')] = csrfField.val();
            var validForm = $("#registeration-form").valid();

            if ($('#js-birthday').val().length < 1 || $('#js-birthday').val().length > 10 ) {
                validForm = false;
                $('.jq-dte').closest('.form-group').find('.invalid-feedback.invalid-birthday').removeClass('d-none');
            } else {
                $('.jq-dte').closest('.form-group').find('.invalid-feedback.invalid-birthday').addClass('d-none');
                validForm = validForm && true;
            }
            
            if(!$('#agree').prop("checked")) {
                validForm = false;
                $('#agree').closest('.form-group').find('.invalid-feedback.invalid-agree').removeClass('d-none');
            } else {
                $('#agree').closest('.form-group').find('.invalid-feedback.invalid-agree').addClass('d-none');
                validForm = validForm && true;
            }

            // $form.find('.form-group.required').find('input,select').each(function () {
            //     if (!$(this).val() && $(this).attr('name')!==undefined) {
            //         validForm = false;
            //         $(this).closest('.form-group').find('.invalid-feedback').removeClass('d-none');
            //     } else if ($(this).is(':checkbox') && !$(this).is(':checked')) {
            //         validForm = false;
            //         $(this).closest('.form-group').find('.invalid-feedback').removeClass('d-none');
            //     } else if ($(this).val().length && $(this).attr('type') === 'tel' && !validation.isValidPhone($(this).val())){
            //         validForm = false;
            //         $(this).closest('.form-group').find('.invalid-feedback.invalid-phone').removeClass('d-none');
            //     }
            //     else if ($(this).val().length && $(this).attr('id') === 'registration-form-password-confirm' && $(this).val() !== $('#registration-form-password').val()){
            //         validForm = false;
            //         $(this).closest('.form-group').find('.invalid-feedback').removeClass('d-none');
            //     }
            //     else if ($(this).val().length && $(this).attr('type') === 'email' && !validation.isValidEmail($(this).val())){
            //         validForm = false;
            //         $(this).closest('.form-group').find('.invalid-feedback.invalid-email').removeClass('d-none');
            //     }
            //      else if($(this).attr('name')!==undefined) {
            //         $(this).closest('.form-group').find('.invalid-feedback').addClass('d-none');
            //     }

            // });

            if (validForm) {
                $.spinner().start();
                // eslint-disable-next-line no-undef
                grecaptcha.ready(function () {
                    // eslint-disable-next-line no-undef
                    grecaptcha.execute(resources.recaptchaSiteKey, { action: 'signup' }).then(function (token) {
                        data.token = token;
                        $.ajax({
                            url: url,
                            type: 'POST',
                            data: data,
                            success: function (response) {
                                if (!response.success) {
                                    // eslint-disable-next-line no-unused-expressions
                                    $.toastr().error(response.message);
                                    $.spinner().stop();
                                    return;
                                }

                                $('#registeration-step-1').fadeOut(50, function () {
                                    $('.new-login-tabs').fadeOut();
                                    $('#registeration-step-2').find('.js-add-number').text(phoneNumber);
                                    $('.js-otp-text').text(response.message);
                                    $('#registeration-step-2').fadeIn(100);
                                    $('.loginBox').hide();
                                    $.spinner().stop();
                                    window.scrollTo(0, 0);
                                    var timer = $('.resendSms').data('enableforseconds');

                                    var counter = timer;
                                    var interval = setInterval(function () {
                                        counter--;
                                        // Display 'counter' wherever you want to display it.
                                        if (counter <= 0) {
                                            clearInterval(interval);
                                            $('.resendSms').removeClass('disabled');
                                            $('.resendSms').removeClass('d-none');
                                            $('.timerText').hide();
                                            $('.timerText span').html(timer);
                                            return;
                                            // eslint-disable-next-line no-else-return
                                        } else {
                                            $('.timerText span').text(counter);
                                        }
                                    }, 1000);
                                });

                                // var token = response.token;
                                // $('.otp-token').val(token);
                                $('.js-btn-save').removeAttr('disabled').removeClass('is-disabled');
                            },
                            error: function (error) {
                                $('.js-register-btn').prop('disabled', false);
                                $('.js-register-btn').removeClass('is-disabled');
                                $.spinner().stop();
                                $.toastr().error(error);
                            }
                        });
                    });
                });
            }
        });
    },

    goBackFromOTP: function () {
        $(document).on('click', '.js-go-back-register-step2', function (e) {
            e.preventDefault();
            $('#registeration-step-2').fadeOut(50, function () {
                $('.singleOtp').val('');
                $('.combineOtp').val('');
                $('#registeration-step-1').fadeIn(100);
                $('.new-login-tabs').fadeIn();
            });
        });
    },
    loginTabs: function () {
        $(document).on('click', '.new-login-tabs a', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $data = $this.data('open');
            var $parent = $this.parent();

            $parent.addClass('active');
            $parent.siblings().removeClass('active');
            $('.loginCard:not(.' + $data + ')').fadeOut(100, function () {
                $('.loginCard.' + $data).fadeIn();
            });
        });
    },
    validateRegisterForm: function () {
        $().ready(function () {

        $("#registeration-form").validate({
            invalidHandler: function(event, validator) {
              // 'this' refers to the form
              var errors = validator.numberOfInvalids();
              if (errors) {
                // var message = errors == 1
                //   ? 'You missed 1 field. It has been highlighted'
                //   : 'You missed ' + errors + ' fields. They have been highlighted';
                // $("div.error span").html(message);
                // $("div.error").show();
                $.toastr().error(resources.mustfilledfield);
              }
            }
          });
          var nameRegex =  /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Zàâçéèêëîïôûùüÿñæœáíóú]+(\s{0,1}[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Zàâçéèêëîïôûùüÿñæœáíóú, {2}])*$/i;
          var emailRegex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,8}|[0-9]{1,3})(\]?)$/;
        $( "#registeration-form #registration-form-fname" ).rules( "add", {
            required: true,
            minlength: 2,
            onlySpace: '#registeration-form #registration-form-fname',
            regex: nameRegex,
            messages: {
                required: resources.Global$firstnameRequired,
                minlength: resources.Global$firstnameMin,
                regex: resources.Global$invalidName,
                onlySpace: resources.Global$nofirstspace
            }
        });
        $( "#registeration-form #registration-form-lname" ).rules( "add", {
            required: true,
            minlength: 2,
            onlySpace: '#registeration-form #registration-form-lname',
            regex: nameRegex,
            messages: {
                required: resources.Global$lastnameRequired,
                minlength: resources.Global$lastnameRequired,
                regex: resources.Global$invalidName,
                onlySpace: resources.Global$nofirstspace
            }
        });
        $( "#registeration-form #registration-form-email" ).rules( "add", {
            required: true,
            email: false,
            regex: emailRegex,
            messages: {
                required: resources.Global$emailRequired,
                regex: resources.Global$invalidEmail
            }
        });
        $( "#registeration-form #registration-form-phone" ).rules( "add", {
            required: true,
            maxlength: 12,
            minlength: 5,
            messages: {
                required: resources.Global$mobileRequired,
                minlength: resources.mobileMinMax,
                maxlength: resources.mobileMinMax,
            }
        });
        $( "#registeration-form #registration-form-gender" ).rules( "add", {
            required: true
        });
        $( "#registeration-form #js-birthday" ).rules( "add", {
            required: true
        });
        $( "#registeration-form #registration-form-password" ).rules( "add", {
            required: true,
            minlength: 8,
            messages: {
                required: resources.Global$passwordRequired,
                minlength: resources.Global$passwordMin,
            }
        });
        $( "#registeration-form #registration-form-password-confirm" ).rules( "add", {
            required: true,
            minlength: 8,
            // For checking both passwords are same or not
            equalTo: "#registration-form-password",
            messages: {
                required: resources.Global$passwordRequired,
                minlength: resources.Global$passwordMin,
                equalTo: resources.Global$passwordequalTo,
            }
        });
    });
    },
    newPasswordForm: function () {
        $('form.change-password-form').on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (data.success) {
                        if(!isMobile) {
                            alert(data.message);
                        }
                        location.href = data.redirectURL;
                    } else if (form.find('.invalid-feedback').length > 0) {
                        form.find('.invalid-feedback').last().html(data.message);
                    } else {
                        alert(data.message);
                    }
                },
                error: function (data) {
                   alert(data.message);
                }
            });
            return false;
        });
    },
};
